module.exports = __webpack_public_path__ + "img/ico-workflow.e3461b47.svg";